export const getLabels = state => {
  const {structure, article, element, elementAnnotations} = state;

  let labels = {};
  if (elementAnnotations.item) {
    elementAnnotations.item.forEach(function (annotation) {
      labels[annotation.id] = plainText(annotation.attributes.label);
    });
  }
  if (element && element.item) {
    labels[element.item.id] = plainText(element.item.attributes.label);
  }
  if (article && article.item) {
    labels[article.item.id] = plainText(article.item.attributes.label);
  }
  if (structure && structure.item) {
    labels[structure.item.id] = plainText(structure.item.attributes.label);
  }

  return labels;

  function plainText(text) {
    return text.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }
};



/** WEBPACK FOOTER **
 ** ./src/modules/laws/selectors.js
 **/